// app/javascript/controllers/file_drop_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fileInput"];

  drop(event) {
    event.preventDefault();
    const { files } = event.dataTransfer;
    if (files.length > 0) {
      this.fileInputTarget.files = files;
      this.fileInputTarget.dispatchEvent(new Event("change"));
    }
  }

  // eslint-disable-next-line class-methods-use-this
  dragOver(event) {
    event.preventDefault();
  }

  // eslint-disable-next-line class-methods-use-this
  dragEnter(event) {
    event.preventDefault();
  }
}
